import { render, staticRenderFns } from "./audioCon.vue?vue&type=template&id=5cd11674&scoped=true&"
import script from "./audioCon.vue?vue&type=script&lang=js&"
export * from "./audioCon.vue?vue&type=script&lang=js&"
import style0 from "./audioCon.vue?vue&type=style&index=0&id=5cd11674&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd11674",
  null
  
)

export default component.exports